// 查看会员信息模块接口
import request from "@/utils/request";

export function GetDetail(data) {
  //查看会员信息
  return request({
    url: "/api/cust/detail",
    method: "POST",
    data: data,
  });
}

export function GetCustSalePage(data) {
  //查看客户交易记录
  return request({
    url: "/api/cust/custSalePage",
    method: "POST",
    data: data,
  });
}

export function GetSaleProductList(data) {
  //顾客购买商品清单
  return request({
    url: "/api/cust/getSaleProductList",
    method: "GET",
    params: data,
  });
}

export function GetQueryCustCoupons(data) {
  //会员劵
  return request({
    url: "/api/cust/queryCustCoupons",
    method: "POST",
    data: data,
  });
}

export function GetQueryCustCommRedemption(data) {
  //兑换记录
  return request({
    url: "/api/cust/queryCustCommRedemption",
    method: "POST",
    data: data,
  });
}

export function GetQueryCustWishList(data) {
  //顾客心愿单列表
  return request({
    url: "/api/cust/queryCustWishList",
    method: "POST",
    data: data,
  });
}

export function GetQueryCustLvlChgLog(data) {
  //顾客心愿单列表
  return request({
    url: "/api/cust/queryCustLvlChgLog",
    method: "POST",
    data: data,
  });
}

export function GetQueryCustPointsLogList(data) {
  //顾客会员积分
  return request({
    url: "/api/cust/queryCustPointsLogList",
    method: "POST",
    data: data,
  });
}

export function GetQueryCustMainChgLog(data) {
  //查看会员—关键信息变更历史
  return request({
    url: "/api/cust/queryCustMainChgLog",
    method: "POST",
    data: data,
  });
}

export function GetSelectByCustID(data) {
  //查看会员—会员预约
  return request({
    url: "/api/cust/appoint/selectByCustID",
    method: "POST",
    data: data,
  });
}

export function GetSelectByCustIDs(data) {
  //查看会员—会员关系
  return request({
    url: "/api/cust/bind/selectByCustID",
    method: "POST",
    data: data,
  });
}

export function GetMaintaiPage(data) {
  //查看会员—客户维护记录
  return request({
    url: "/api/cust/maintain/page",
    method: "POST",
    data: data,
  });
}

export function GetUpdressPage(data) {
  //查看会员—改衣单记录
  return request({
    url: "/api/cust/updress/page",
    method: "POST",
    data: data,
  });
}

export function GetCustRecvAddress(data) {
  //查看会员—会员地址
  return request({
    url: "/api/cust/custRecvAddress",
    method: "POST",
    data: data,
  });
}

export function GetSpecdateInsert(data) {
  //顾客特殊日期（添加）
  return request({
    url: "/api/cust/specdate/insert",
    method: "POST",
    data: data,
  });
}

export function GetSpecdateUpdate(data) {
  //顾客特殊日期（修改）
  return request({
    url: "/api/cust/specdate/update",
    method: "POST",
    data: data,
  });
}

export function GetSpecdateDeletee(data) {
  //顾客特殊日期（删除）
  return request({
    url: "/api/cust/specdate/delete",
    method: "POST",
    data: data,
  });
}

export function GetQueryCustSpecDate(data) {
  //查看会员—会员特殊日期
  return request({
    url: "/api/cust/queryCustSpecDate",
    method: "POST",
    data: data,
  });
}

export function GetShopQueryRegion(data) {
  //查询区域
  return request({
    url: "/api/shop/queryRegion",
    method: "POST",
    data: data,
  });
}

export function GetShopSelectList(data) {
  //门店下拉框
  return request({
    url: "/api/shop/selectList",
    method: "POST",
    data: data,
  });
}

export function EmpSelectEmp(data) {
  //下拉框选择员工
  return request({
    url: "/sys/emp/selectEmp",
    method: "POST",
    data: data,
  });
}

export function UpdateService(data) {
  //会员转店申请
  return request({
    url: "/api/cust/updateService",
    method: "POST",
    data: data,
  });
}

export function GetSelectList(data) {
  //原因定义下拉框
  return request({
    url: "/api/reason/selectList",
    method: "POST",
    data: data,
  });
}

export function CustlvlQuerySelect(data) {
  //客户等级下拉框
  return request({
    url: "/api/Custlvl/querySelect",
    method: "POST",
    data: data,
  });
}

export function CustLvlRequestInsert(data) {
  //修改会员消费等级
  return request({
    url: "/api/custLvlRequest/insert",
    method: "POST",
    data: data,
  });
}

export function unbind(data) {
  //解绑微信
  return request({
    url: "/api/cust/unbind",
    method: "GET",
    params: data,
  });
}

export function UpdateCardNo(data) {
  //会员卡号变更
  return request({
    url: "/api/cust/updateCardNo",
    method: "POST",
    data: data,
  });
}

export function Freezeinsert(data) {
  //冻结
  return request({
    url: "/api/cust/freeze/insert",
    method: "POST",
    data: data,
  });
}

export function FreezeThaw(data) {
  //解冻
  return request({
    url: "/api/cust/freeze/thaw",
    method: "POST",
    data: data,
  });
}

export function bindSelectPage(data) {
  //会员绑定列表数据
  return request({
    url: "/api/cust/bind/selectPage",
    method: "POST",
    data: data,
  });
}

export function bindInsert(data) {
  //添加
  return request({
    url: "/api/cust/bind/insert",
    method: "POST",
    data: data,
  });
}

export function bindupdate(data) {
  //修改
  return request({
    url: "/api/cust/bind/update",
    method: "POST",
    data: data,
  });
}

export function binddelete(data) {
  //删除
  return request({
    url: "/api/cust/bind/delete",
    method: "POST",
    data: data,
  });
}

export function selectCustListApi(data) {
  //查看所有会员列表
  return request({
    url: "/api/cust/selectCustList",
    method: "POST",
    data: data,
  });
}

export function managerPage(data) {
  //大客户经理列表
  return request({
    url: "/api/acc/manager/page",
    method: "POST",
    data: data,
  });
}

export function uploadImg(data) {
  //保存单个图片
  return request({
    url: "/api/uploadImg?type=1",
    method: "POST",
    data: data,
  });
}

export function selectEmpList(data) {
  //选择员工
  return request({
    url: "/sys/emp/selectEmpList",
    method: "POST",
    data: data,
  });
}

export function managerInsert(data) {
  //添加大客户经理
  return request({
    url: "/api/acc/manager/insert",
    method: "POST",
    data: data,
  });
}

export function managerQuery(data) {
  //大客户经理查看详情
  return request({
    url: "/api/acc/manager/query",
    method: "POST",
    data: data,
  });
}

export function managerDelete(data) {
  //大客户经理删除
  return request({
    url: "/api/acc/manager/delete",
    method: "POST",
    data: data,
  });
}

export function managerUpdate(data) {
  //大客户经理修改
  return request({
    url: "/api/acc/manager/update",
    method: "POST",
    data: data,
  });
}

//会员信息—查看会员—客户交易记录—明细
export function queryOrderDetailApi(data) {
  return request({
    url: "/api/cust/queryOrderDetail",
    method: "POST",
    data: data,
  });
}

//根据SKU获取商品信息
export function queryBySkuApi(data) {
  return request({
    url: "/api/product/queryBySku",
    method: "POST",
    data: data,
  });
}

// 获取微信换绑审核列表
export function queryReqbindunionList(data) {
  return request({
    url: "/api/cust/reqbindunionList",
    method: "POST",
    data: data,
  });
}


// 微信换绑批量审核接口
export function bindBatchWx(data) {
  return request({
    url: "/api/cust/bindBatchWx",
    method: "POST",
    data: data,
  });
}

// 微信换绑批量拒接审核
export function bindWxrBatchRefuse(data) {
  return request({
    url: "/api/cust/bindWxrBatchRefuse",
    method: "POST",
    data: data,
  });
}

// 转赠记录
export function transferRecord(data) {
  return request({
    url: "/api/couponGive/transfer",
    method: "POST",
    data: data,
  });
}

// 接收记录
export function receiveRecord(data) {
  return request({
    url: "/api/couponGive/receiver",
    method: "POST",
    data: data,
  });
}

// 赠送记录
export function giftRecord(data) {
  return request({
    url: "/api/couponGive/list",
    method: "POST",
    data: data,
  });
}
